// src/components/AccountLayout.js
import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

const LayoutContainer = styled.div`
  display: flex;
  max-width: 1200px;
  margin: 0 auto;
  gap: 30px;
`;

const Sidebar = styled.div`
  width: 250px;
`;

const SidebarNav = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 20px;
  
  a {
    padding: 10px 15px;
    border-radius: 5px;
    text-decoration: none;
    color: #333;
    
    &.active {
      background-color: #f0f0f0;
      color: #007bff;
      font-weight: bold;
    }
    
    &:hover {
      background-color: #f8f8f8;
    }
  }
`;

const Content = styled.div`
  flex: 1;
`;

const AccountLayout = ({ children }) => {
  return (
    <LayoutContainer>
      <Sidebar>
        <h2>My Account</h2>
        <SidebarNav>
          <NavLink to="/account/profile">Profile</NavLink>
          <NavLink to="/account/settings">Settings</NavLink>
          {/* Hidden billing/credits navigation (uncomment to re-enable) */}
          {/* <NavLink to="/account/billing">Billing</NavLink> */}
          {/* <NavLink to="/account/credits">Credits</NavLink> */}
        </SidebarNav>
      </Sidebar>
      <Content>
        {children}
      </Content>
    </LayoutContainer>
  );
};

export default AccountLayout;